import { forwardRef } from "react";
import "./_switch.scss";

/**
 * Pure-UI on/off toggle. Replaces `src/components/ui/Switch` (a bare
 * `{isOn, handleClick}` div-based toggle with no `_components/ui`
 * equivalent) - built fresh on BEM + `_styles/abstracts` tokens rather than
 * moved verbatim, matching every other primitive rebuilt-on-move this
 * session.
 *
 * A real `<button role="switch">`, not a click-catching `<div>`, so it's
 * keyboard operable and announces its state to assistive tech for free.
 */
const Switch = forwardRef(function Switch(
  { isOn = false, onToggle, disabled = false, label, id, className = "" },
  ref
) {
  return (
    <button
      ref={ref}
      id={id}
      type="button"
      role="switch"
      aria-checked={isOn}
      aria-label={label}
      disabled={disabled}
      className={`switch ${isOn ? "switch--on" : ""} ${className}`.trim()}
      onClick={() => !disabled && onToggle?.(!isOn)}
    >
      <span className="switch__handle" />
    </button>
  );
});

export default Switch;
